import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const register = (registerData) => {
    return instance.post(apis.Invitation.Register, registerData)
}

const list = (data) => {
    return instance.post(apis.Invitation.List, data)
}

const post = (data) => {
    return instance.post(apis.Invitation.Update, data)
}

export default {
    register,
    list,
    post
}